export default __webpack_public_path__ + "static/media/postSuvinil3.bd67fd2b.png";